import { Link, useLocation } from 'react-router-dom';
import Icon from '../Icon/Icon';
import ThemeSwitch from '../ThemeSwitch';
import './Sidebar.scss';

export default function Sidebar() {
  const location = useLocation();

  const menuItems = [
    { icon: 'dash', label: 'Início', path: '/menu-de-conta' },
    { icon: 'person', label: 'Perfil', path: '/perfil/sobre' },
    // {
    //   icon: 'chat',
    //   label: 'Novidades',
    //   path: '/menu-de-conta/preferencias-de-comunicacao'
    // },
    {
      icon: 'shield',
      label: 'Segurança',
      path: '/perfil/seguranca'
    },
    {
      icon: 'setting',
      label: 'Configurações',
      path: '/perfil/preferencias'
    }
  ];

  const menuLinks = [
    { icon: 'sbtsports', label: 'Sports', url: 'https://sports.sbt.com.br/' },
    { icon: 'sbtnews', label: 'News', url: 'https://sbtnews.sbt.com.br/' },
    { icon: 'sbttv', label: 'TV', url: 'https://tv.sbt.com.br/' },
    { icon: 'maissbt', label: '+SBT', url: 'https://mais.sbt.com.br/' }
  ];

  return (
    <div className="sidebar">
      <Icon name="logoSbt" />

      <div className="sidebar__items">
        {menuItems.map((item) => {
          const isActive =
            location.pathname === item.path ||
            (item.path !== '/menu-de-conta' &&
              location.pathname.startsWith(item.path));

          return (
            <Link
              key={item.label}
              to={item.path}
              className={`sidebar__item ${isActive ? 'active' : ''}`}
            >
              <div className="sidebar__item__status" />
              <div className="sidebar__item__data internal">
                <Icon name={item.icon} />
                {!isActive && <p>{item.label}</p>}
              </div>
            </Link>
          );
        })}

        <div className="divider" />

        {menuLinks.map((item) => (
          <a
            key={item.label}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className="sidebar__item"
          >
            <div className="sidebar__item__status" />
            <div className="sidebar__item__data">
              <Icon name={item.icon} />
              <p className="internal">
                <Icon name="link" />
                {item.label}
              </p>
            </div>
          </a>
        ))}
      </div>

      <div className="sidebar__footer">
        <ThemeSwitch />
      </div>
    </div>
  );
}
